{
  "WALLBOARD": {
    "LOADING": "Se încarcă cozile de apeluri...",
    "NO_QUEUES": "Nu s-au găsit cozi de apeluri.",
    "AGENTS": "Agenți",
    "NO_AGENTS": "Niciun agent online în această coadă.",
    "NO_AGENTS_ONLINE": "Niciun agent online.",
    "WAITING_CALLERS": "Apelanți în așteptare",
    "NO_CALLERS": "Niciun apelant în așteptare.",
    "UNKNOWN_CALLER": "Apelant necunoscut",
    "POSITION": "Poziție",
    "STATUS": "Stare",
    "TIME": "Durată",
    "AGENT": "Agent",
    "EXTENSION": "Interior",
    "AVAILABLE": "Disponibil",
    "READY": "Agenți pregătiți",
    "ON_CALL": "Agenți în apel",
    "QUEUE_CALL": "Apel din coadă",
    "OTHER_CALL": "Alt apel",
    "PAUSED": "Agenți în pauză",
    "WAITING": "Apeluri în așteptare",
    "MISSED_CALLS": "Apeluri pierdute",
    "HANDLED_CALLS": "Apeluri primite gestionate",
    "OUTBOUND_CALLS": "Apeluri efectuate gestionate",
    "AVAILABILITY": "Disponibilitate",
    "AVAILABILITY_TOOLTIP": "Procentul de apeluri primite la care au răspuns agenții (apeluri care au fost preluate)",
    "TOTAL": "total",
    "AGENTS_COUNT": "({onCall} în apel / {total} în total)",
    "NO_AVAILABLE": "(nimeni online)",
    "WAITING_CALLERS_COUNT": "{count} în așteptare",
    "CALLER": "Apelant",
    "NUMBER": "Număr",
    "WAIT_TIME": "Timp de așteptare",
    "QUEUES": "Cozi",
    "ACTION": "Acțiune",
    "PICKUP_CALL": "Preia",
    "PICKING_UP": "Se preia...",
    "PICKUP_SUCCESS": "Preluarea apelului a fost solicitată cu succes.",
    "PICKUP_ERROR": "Nu s-a putut prelua apelul. Vă rugăm să încercați din nou.",
    "PICKUP_DISABLED_TOOLTIP": "Nu puteți prelua un apel în timp ce sunteți într-un apel sau offline.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Fără acces"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Fără acces"
    }
  }
}
